import { styledOmitCustomProps } from '@braskai/ui-kit';

import { Box, css, styled } from '@mui/material';

export const SContainer = styled(Box)(({ theme }) => ({
  height: '100svh',
  display: 'grid',
  gap: 32,

  [theme.breakpoints.up('laptop')]: {
    gap: 'unset',
    gridTemplateColumns: '400px 1fr',
  },
  [theme.breakpoints.up('desktop')]: {
    gap: 'unset',
    gridTemplateColumns: '45% 55%',
  },
}));

type SContentProps = {
  $withoutPadding?: boolean;
};

export const SContent = styled(
  Box,
  styledOmitCustomProps,
)<SContentProps>(
  ({ theme, $withoutPadding }) => css`
    display: contents;

    ${theme.breakpoints.up('laptop')} {
      display: grid;
      grid-template-rows: min-content 1fr min-content;
      width: 360px;
      justify-self: center;
      padding-top: ${$withoutPadding ? 0 : '99px'};
    }
  `,
);

export const SFormsContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  justifyItems: 'center',

  [theme.breakpoints.up('laptop')]: {
    alignItems: 'center',
  },
}));

export const SLogo = styled('img')(
  ({ theme }) => css`
    justify-self: center;
    align-self: end;

    ${theme.breakpoints.up('laptop')} {
      justify-self: left;
    }
  `,
);
